"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { FUSportsMatchEvent } from "fansunited-data-layer";
import { GoalCard } from "./GoalCard";
import { SubstitutionCard } from "./SubstitutionCard";
import { CardEventCard } from "./CardEventCard";
import { GenericEventCard } from "./GenericEventCard";
import { isGoalEvent, type EventLabels } from "./matchEventHelpers";
interface EventCardProps {
  event: FUSportsMatchEvent;
  showPhotos: boolean;
  eventLabels: EventLabels;
}

/**
 * EventCard - Routes to the appropriate card component based on event type
 */
export const EventCard: React.FC<EventCardProps> = t0 => {
  const $ = _c(15);
  const {
    event,
    showPhotos,
    eventLabels
  } = t0;
  if (isGoalEvent(event.type)) {
    let t1;
    if ($[0] !== event || $[1] !== eventLabels || $[2] !== showPhotos) {
      t1 = <GoalCard event={event} showPhotos={showPhotos} eventLabels={eventLabels} />;
      $[0] = event;
      $[1] = eventLabels;
      $[2] = showPhotos;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    return t1;
  }
  if (event.type === "SUBSTITUTION") {
    let t1;
    if ($[4] !== event || $[5] !== eventLabels || $[6] !== showPhotos) {
      t1 = <SubstitutionCard event={event} showPhotos={showPhotos} eventLabels={eventLabels} />;
      $[4] = event;
      $[5] = eventLabels;
      $[6] = showPhotos;
      $[7] = t1;
    } else {
      t1 = $[7];
    }
    return t1;
  }
  if (["YELLOW_CARD", "RED_CARD", "YELLOW_RED_CARD"].includes(event.type)) {
    let t1;
    if ($[8] !== event || $[9] !== eventLabels || $[10] !== showPhotos) {
      t1 = <CardEventCard event={event} showPhotos={showPhotos} eventLabels={eventLabels} />;
      $[8] = event;
      $[9] = eventLabels;
      $[10] = showPhotos;
      $[11] = t1;
    } else {
      t1 = $[11];
    }
    return t1;
  }
  let t1;
  if ($[12] !== event || $[13] !== eventLabels) {
    t1 = <GenericEventCard event={event} eventLabels={eventLabels} />;
    $[12] = event;
    $[13] = eventLabels;
    $[14] = t1;
  } else {
    t1 = $[14];
  }
  return t1;
};